import { Container } from 'ui';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { StoreType, useActions } from '@tock/shared/utils/connect';
import { guestImageUrl } from '@tock/images';
import { headerNavigation } from 'routes/protected/account/profile/profileRouteCssDefs';
import { useMountEffect } from '@tock/hooks';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import AchievementsModal from 'components/profile/achievements/AchievementsModal';
import EditProfileModal from 'components/profile/EditProfileModal';
import ProfileHeader from 'components/profile/ProfileHeader';
import ProfileHeaderNavigation from 'components/profile/ProfileHeaderNavigation';
import ProfileOverviewRoute from 'routes/protected/account/profile/ProfileOverviewRoute';
import ProfilePlaylistsRoute from './ProfilePlaylistsRoute';
import ProfileReservationsRoute from 'routes/protected/account/profile/ProfileReservationsRoute';
import QuizModal from 'components/profile/quiz/QuizModal';
import clsx from 'clsx';

const ProfileRoute = () => {
  const [isAchievementsModalOpen, setIsAchievementsModalOpen] = useState(false);

  const { actions } = useActions();
  const match = useRouteMatch();
  const location = useLocation();

  const { app, patron } = useSelector((state: StoreType) => ({
    app: state.app,
    patron: state.patron,
  }));

  useMountEffect(() => {
    if (
      !(
        patron.isAchievementsInitialized &&
        patron.isAllAchievementsInitialized &&
        patron.isPreferenceOptionsInitialized
      )
    ) {
      actions.patron.fetchAchievements();
      actions.patron.fetchAllAchievements();
      actions.patron.fetchAllPreferenceOptions();
    }
    actions.navigation.set({ title: 'Profile' });
  });

  const { patronProfile, patron: appPatron, patronProfilePlace } = app;

  if (!patronProfile) {
    return null;
  }
  const viewingReservations = location.pathname.includes('reservations');
  const viewingPlaylists = location.pathname.includes('saved');
  return (
    <div className={clsx('MainContent', 'ProfileRoute')}>
      <div className="Profile-headerSection">
        {appPatron && (
          <ProfileHeader
            setAchievementsModalIsOpen={setIsAchievementsModalOpen}
            patron={appPatron}
            patronProfilePlaceDescription={patronProfilePlace?.description}
          />
        )}
        <Container css={headerNavigation}>
          <ProfileHeaderNavigation
            viewingTab={
              viewingReservations ? 'reservations' : viewingPlaylists ? 'saved' : 'overview'
            }
          />
        </Container>
      </div>
      <Switch location={location}>
        <Route exact path={`${match.path}`} component={ProfileOverviewRoute} />
        <Route path={`${match.path}/reservations`} component={ProfileReservationsRoute} />
        <Route path={`${match.path}/saved`} component={ProfilePlaylistsRoute}></Route>
      </Switch>
      <EditProfileModal
        patronImageUrl={(appPatron && guestImageUrl(appPatron.imageUrl, 400)) || undefined}
        patronProfile={patronProfile}
        patronProfilePlace={patronProfilePlace}
      />
      <AchievementsModal
        isOpen={isAchievementsModalOpen}
        onSetAchievementsModalIsOpen={setIsAchievementsModalOpen}
      />
      <QuizModal />
    </div>
  );
};

export default ProfileRoute;
